import {
  Box,
  Fade,
  Grid,
  Grow,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";

import Header from "../Header";
import SectionLayout from "../../layouts/SectionLayout";
import SlideTransition from "../SlideTransition";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";
import { MAIN_ROUTES } from "../../utils/routes";

import { styles } from "./style";
import { theme } from "../../utils/theme";

const Values = () => {
  const content = useContent();
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [setRef, visible] = useInView({
    threshold: matches ? 0.1 : 0.3,
  });

  return (
    <SectionLayout
      id={MAIN_ROUTES.get("VALUES").ID}
      style={{
        backgroundColor: theme.palette.grays.white,
      }}
    >
      <Stack ref={setRef} spacing={20} sx={styles.root}>
        <SlideTransition appear={visible} timeout={800}>
          <Stack spacing={6} alignItems={"center"}>
            <Header
              center={true}
              data={content.values}
              decorationPos={"bottom"}
            />
          </Stack>
        </SlideTransition>

        <Grid container direction={"row"} spacing={0} sx={styles.body}>
          {content.values.items.map((item, idx) => {
            return (
              <Grid item key={idx} xs={12} sm={6} md={4}>
                <Stack spacing={6} sx={styles.item}>
                  <Grow in={visible} timeout={idx * 900}>
                    {/* Image */}
                    <img
                      alt={item.header}
                      src={item.image}
                      style={{
                        height: "auto",
                        width: matches ? "24vw" : "30%",
                      }}
                    />
                  </Grow>

                  {/* Content */}
                  <Fade in={visible} timeout={idx * 1000}>
                    <Stack spacing={6} sx={{ alignItems: "center" }}>
                      <Typography sx={styles.itemHeader}>
                        {item.header}
                      </Typography>

                      <Typography sx={styles.itemBody}>
                        {item.content}
                      </Typography>
                    </Stack>
                  </Fade>
                </Stack>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </SectionLayout>
  );
};

export default Values;
